import React, { lazy } from 'react'
import debtorAccountRoutes from './DebtorAccountModule/DebtorAccountRoutes'

const DebtorListing = lazy(() =>
  import('./DebtorListing').then(module => ({
    default: module.DebtorListing,
  }))
)

const DebtorProfile = lazy(() =>
  import('./DebtorProfile').then(module => ({
    default: module.DebtorProfile,
  }))
)

const debtorRoutes = [
  {
    props: { exact: true, path: '/debtor' },
    component: <DebtorListing />,
  },
  {
    props: { exact: true, path: '/' },
    component: <DebtorListing />,
  },
  {
    props: { exact: true, path: '/home' },
    component: <DebtorListing />,
  },
  {
    props: { exact: true, path: '/debtor/profile/:debtorID' },
    component: <DebtorProfile />,
  },
]

debtorAccountRoutes.forEach(route => {
  debtorRoutes.push(route)
})


export default debtorRoutes
